import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGlobalShopSettingsSelector } from '../../modules/selectors';
import { getGlobalShopSettingsForCurrentUser } from '../../modules/actions';

interface IUseGlobalShopSettingsOptions {
  fetch?: boolean;
}

export const useGlobalShopSettings = ({ fetch = true }: IUseGlobalShopSettingsOptions = {}) => {
  const dispatch = useDispatch();
  const globalShopSettings = useSelector(getGlobalShopSettingsSelector);

  useEffect(() => {
    if (fetch) {
      dispatch(getGlobalShopSettingsForCurrentUser());
    }
  }, [dispatch, fetch]);

  const isGlobalShopActive = globalShopSettings ? !!globalShopSettings.printShopActive : true;

  return { globalShopSettings, isGlobalShopActive };
};
